import { render, staticRenderFns } from "./QuickPriceWarn.vue?vue&type=template&id=a5e098aa&scoped=true&"
import script from "./QuickPriceWarn.vue?vue&type=script&lang=js&"
export * from "./QuickPriceWarn.vue?vue&type=script&lang=js&"
import style0 from "./QuickPriceWarn.vue?vue&type=style&index=0&id=a5e098aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e098aa",
  null
  
)

export default component.exports